import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { AppEventService } from '../../events.service';
import { AppStudentsService } from '../../../students/students.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppToastManagerService } from '../../../../shared/services/toast-manager.service';
import { BaseComponent } from '../../../../shared/base-classes/base.component';
import { ScheduledHeroEventStudentListItemDto, StudentBehaviorHistoryResponseDto, StudentDetailResponseDto } from '@whetstoneeducation/hero-common';

@Component({
  selector: 'app-scheduled-hero-event-overdue-actions-dialog',
  templateUrl: './scheduled-hero-event-overdue-actions-dialog.component.html',
  styleUrls: ['./scheduled-hero-event-overdue-actions-dialog.component.scss']
})
export class ScheduledHeroEventOverdueActionsDialogComponent
  extends BaseComponent
  implements OnDestroy, OnInit {
  public student: StudentDetailResponseDto;

  constructor(
    public eventsService: AppEventService,
    public studentsService: AppStudentsService,
    public dialogRef: MatDialogRef<ScheduledHeroEventOverdueActionsDialogComponent>,
    public toastService: AppToastManagerService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      student: ScheduledHeroEventStudentListItemDto;
      reactions: StudentBehaviorHistoryResponseDto[];
      eventId: number;
      onClose: () => Promise<void>;
    }
  ) {
    super();
  }

  ngOnInit(): void {
    this.loadData();
  }

  public get overdueReactions() {
    return this.data.reactions;
  }

  async loadData() {
    this.student = await this.studentsService.getStudentById(this.data.student.studentId);
  }

  async ngOnDestroy() {
    await this.data.onClose();
  }

  async checkInOutStudent() {
    await this.eventsService.checkInOutEventStudent(this.data.student, this.data.eventId);
    this.toastService.success(`${this.data.student.name} has been checked in`);
    this.handleClose();
  }

  async handleClose() {
    await this.data.onClose();
    this.dialogRef.close();
  }

}
